import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { ButtonGroup } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import InstallMobileOutlinedIcon from '@mui/icons-material/InstallMobileOutlined'
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SidebarAction from '/components/sidebar-action'
import DeleteSelectedPassesDialog from './delete-selected-passes-dialog'

const ManagePassesMenu = ({ template, selectedPass, selectedPasses, onSelectedPassesDeleted }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [deleteSelectedOpen, setDeleteSelectedOpen] = useState(false)
  const selection = normalisePassSelection(selectedPasses)
  const multipleSelected = selection.count > 1
  const selectedLoadedPasses = selection.type === 'allMatching' ? selection.loadedPasses : selection.passes
  const passSelected = Boolean(selectedPass)
  const isManagedTemplate = Number(template?.managed_pass_template) === 1
  const isRoute = route => location.pathname.endsWith(`/${route}`)

  const navigateToPass = path => navigate(`/templates/${template.template_id}/passes/${selectedPass.pass_id}/${path}`, { state: { pass: selectedPass } })
  const editSelectedPasses = () => navigate(`/templates/${template.template_id}/passes/edit-selected`, { state: { selection } })

  if (!template) return null

  return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <ButtonGroup variant="text" aria-label="Manage passes actions">
          <SidebarAction label="View pass details" icon={<OpenInNewIcon />} active={isRoute('details')} disabled={!passSelected} onClick={() => navigateToPass('details')} />
          <SidebarAction label="Edit pass" icon={<EditOutlinedIcon />} active={isRoute('edit')} disabled={!passSelected} onClick={() => navigateToPass('edit')} />
          <SidebarAction label="Pass actions" icon={<QrCodeScannerOutlinedIcon />} active={isRoute('scan-actions')} disabled={!passSelected || !isManagedTemplate} onClick={() => navigateToPass('scan-actions')} />
          <SidebarAction label="Scan history" icon={<HistoryOutlinedIcon />} active={isRoute('scans')} disabled={!passSelected || !isManagedTemplate} onClick={() => navigateToPass('scans')} />
          <SidebarAction label="Install pass" icon={<InstallMobileOutlinedIcon />} active={isRoute('install')} disabled={!passSelected} onClick={() => navigateToPass('install')} />
        <SidebarAction label="Edit selected passes" icon={<SystemUpdateAltOutlinedIcon />} active={isRoute('edit-selected')} disabled={!multipleSelected} onClick={editSelectedPasses} />
        <SidebarAction label="Delete selected passes" icon={<DeleteOutlineIcon />} disabled={!selectedLoadedPasses.length} onClick={() => setDeleteSelectedOpen(true)} />
      </ButtonGroup>
      <DeleteSelectedPassesDialog open={deleteSelectedOpen} setOpen={setDeleteSelectedOpen} selection={selection} onDeleted={onSelectedPassesDeleted} />
    </div>
  )
}

export default ManagePassesMenu

const normalisePassSelection = selection => Array.isArray(selection)
  ? { type: 'loaded', count: selection.length, mode: 'live', passes: selection }
  : selection ?? { type: 'loaded', count: 0, mode: 'live', passes: [] }
